import { Pipe, PipeTransform } from '@angular/core';
import { GalleryStatus } from '@nusign/picflow-backend-types';

export const getGalleryStatusIcon = (status: GalleryStatus): string => {
  if (status === 'approved') return 'check-hex';
  if (status === 'no_status') return 'circle-dotted';
  if (status === 'progress') return 'clock-outline';
  if (status === 'review') return 'circle-double';
  if (status === 'revisions') return 'cross-revert';
};

@Pipe({
  name: 'galleryStatusIcon',
  standalone: true,
})
export class GalleryStatusIconPipe implements PipeTransform {
  transform(status: GalleryStatus): string {
    return getGalleryStatusIcon(status);
  }
}
